var render = function render(){var _vm=this,_c=_vm._self._c;return _c('navigation-tabs',{staticClass:"merge-request-navigation-bar",attrs:{"is-reactive":true,"links":_vm.filteredMenuItems}})
}
var staticRenderFns = []

export { render, staticRenderFns }